/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CalendarDataResponse } from "./CalendarDataResponse";
import {
  CalendarDataResponseFromJSON,
  CalendarDataResponseFromJSONTyped,
  CalendarDataResponseToJSON,
  CalendarDataResponseToJSONTyped,
} from "./CalendarDataResponse";

/**
 *
 * @export
 * @interface CompanyCalendarDataResponse
 */
export interface CompanyCalendarDataResponse {
  /**
   *
   * @type {CalendarDataResponse}
   * @memberof CompanyCalendarDataResponse
   */
  bookedRevenue: CalendarDataResponse;
  /**
   *
   * @type {CalendarDataResponse}
   * @memberof CompanyCalendarDataResponse
   */
  numberBooked: CalendarDataResponse;
  /**
   *
   * @type {CalendarDataResponse}
   * @memberof CompanyCalendarDataResponse
   */
  numberQuotes: CalendarDataResponse;
  /**
   *
   * @type {CalendarDataResponse}
   * @memberof CompanyCalendarDataResponse
   */
  winRatesPerMonth: CalendarDataResponse;
}

/**
 * Check if a given object implements the CompanyCalendarDataResponse interface.
 */
export function instanceOfCompanyCalendarDataResponse(
  value: object,
): value is CompanyCalendarDataResponse {
  if (!("bookedRevenue" in value) || value["bookedRevenue"] === undefined)
    return false;
  if (!("numberBooked" in value) || value["numberBooked"] === undefined)
    return false;
  if (!("numberQuotes" in value) || value["numberQuotes"] === undefined)
    return false;
  if (!("winRatesPerMonth" in value) || value["winRatesPerMonth"] === undefined)
    return false;
  return true;
}

export function CompanyCalendarDataResponseFromJSON(
  json: any,
): CompanyCalendarDataResponse {
  return CompanyCalendarDataResponseFromJSONTyped(json, false);
}

export function CompanyCalendarDataResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyCalendarDataResponse {
  if (json == null) {
    return json;
  }
  return {
    bookedRevenue: CalendarDataResponseFromJSON(json["bookedRevenue"]),
    numberBooked: CalendarDataResponseFromJSON(json["numberBooked"]),
    numberQuotes: CalendarDataResponseFromJSON(json["numberQuotes"]),
    winRatesPerMonth: CalendarDataResponseFromJSON(json["winRatesPerMonth"]),
  };
}

export function CompanyCalendarDataResponseToJSON(
  json: any,
): CompanyCalendarDataResponse {
  return CompanyCalendarDataResponseToJSONTyped(json, false);
}

export function CompanyCalendarDataResponseToJSONTyped(
  value?: CompanyCalendarDataResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    bookedRevenue: CalendarDataResponseToJSON(value["bookedRevenue"]),
    numberBooked: CalendarDataResponseToJSON(value["numberBooked"]),
    numberQuotes: CalendarDataResponseToJSON(value["numberQuotes"]),
    winRatesPerMonth: CalendarDataResponseToJSON(value["winRatesPerMonth"]),
  };
}
